var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "礼包ID / Name：",
      "label-width": "120px"
    }
  }, [_c("couponOptions", {
    attrs: {
      type: 2,
      couponArray: _vm.couponArray
    },
    model: {
      value: _vm.searchInfo.coupon_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "coupon_id", $$v);
      },
      expression: "searchInfo.coupon_id"
    }
  })], 1), _c("el-form-item", [[_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.refresh();
      }
    }
  }, [_vm._v("查询")]), _c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: function click($event) {
        return _vm.openConfig();
      }
    }
  }, [_vm._v("同步cp配置")])]], 2)], 1)], 1), _c("div", [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "row-key": "authorityId",
      stripe: "",
      height: "600"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "礼包ID",
      prop: "coupon_id",
      width: 90
    }
  }), _c("el-table-column", {
    attrs: {
      label: "礼包名称",
      prop: "coupon_name",
      width: 180
    }
  }), _c("el-table-column", {
    attrs: {
      label: "开始时间",
      prop: "start_time",
      width: 160
    }
  }), _c("el-table-column", {
    attrs: {
      label: "结束时间",
      prop: "end_time",
      width: 160
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_c("span", {
          style: {
            color: _vm.nowStr > row.end_time ? "red" : ""
          }
        }, [_vm._v(" " + _vm._s(row.end_time) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "礼包内容",
      prop: "coupon_desc"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "是否可重复领取",
      prop: "repeat_type",
      width: 165
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.repeat_type == 1 ? _c("span", [_vm._v("不可重复")]) : _vm._e(), scope.row.repeat_type == 2 ? _c("span", [_vm._v(" 可重复 "), scope.row.limit > 0 ? _c("span", {
          staticStyle: {
            color: "rgb(41, 172, 52)"
          }
        }, [_vm._v(" （每天" + _vm._s(scope.row.limit) + "次） ")]) : _vm._e()]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "礼包码类型",
      prop: "coupon_type",
      width: 92
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.coupon_type == 1 ? _c("span", [_vm._v("专码")]) : _vm._e(), scope.row.coupon_type == 2 ? _c("span", [_vm._v("通码")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "礼包码",
      prop: "coupon_type",
      width: 120
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.coupon_type == 1 ? _c("el-button", {
          on: {
            click: function click($event) {
              return _vm.openBatchDialog(scope.row);
            }
          }
        }, [_vm._v("查看")]) : [_vm._v(" " + _vm._s(scope.row.coupon_code) + " ")]];
      }
    }])
  })], 1), _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [10, 30, 50, 100],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm.couponBatchVisible ? _c("el-dialog", {
    attrs: {
      title: "礼包码生成记录",
      width: "80%",
      visible: _vm.couponBatchVisible,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.couponBatchVisible = $event;
      }
    }
  }, [_c("ShowCouponBatch", {
    ref: "batchDialog",
    attrs: {
      data: _vm.selectedCoupon
    },
    on: {
      generate: _vm.openGenerateDialog
    }
  })], 1) : _vm._e(), _vm.couponGenerateVisible ? _c("el-dialog", {
    attrs: {
      title: "礼包码生成",
      width: "400px",
      visible: _vm.couponGenerateVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.couponGenerateVisible = $event;
      }
    }
  }, [_c("ShowCouponGenerate", {
    attrs: {
      data: _vm.selectedCoupon
    },
    on: {
      generateDone: _vm.onGenerateDone
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };